// Click-to-enlarge for screenshot previews. Any element with
// [data-lightbox] opens its data-lightbox-large URL in a fullscreen
// overlay. Close: click anywhere, Esc. Focus returns to the opener.
;(function () {
  let overlay = null
  let opener = null

  function ensureOverlay() {
    if (overlay) return overlay
    overlay = document.createElement("div")
    overlay.className =
      "fixed inset-0 z-[100] hidden items-center justify-center bg-black/85 backdrop-blur-sm p-4 md:p-10 cursor-zoom-out"
    overlay.setAttribute("role", "dialog")
    overlay.setAttribute("aria-modal", "true")
    overlay.setAttribute("aria-label", "Screenshot preview")

    const img = document.createElement("img")
    img.className =
      "max-w-full max-h-full rounded-lg shadow-[0_8px_32px_rgba(0,0,0,0.6)] select-none"
    overlay.appendChild(img)

    overlay.addEventListener("click", close)
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !overlay.classList.contains("hidden")) close()
    })
    document.body.appendChild(overlay)
    return overlay
  }

  function open(src, alt, openerEl) {
    opener = openerEl
    const el = ensureOverlay()
    const img = el.querySelector("img")
    img.src = src
    img.alt = alt || ""
    el.classList.remove("hidden")
    el.classList.add("flex")
    document.body.style.overflow = "hidden"
    el.focus?.()
  }

  function close() {
    if (!overlay) return
    overlay.classList.add("hidden")
    overlay.classList.remove("flex")
    overlay.querySelector("img").src = ""
    document.body.style.overflow = ""
    opener?.focus?.()
    opener = null
  }

  function openFrom(target) {
    const large = target.getAttribute("data-lightbox-large") || target.src
    open(large, target.alt, target)
  }

  document.addEventListener("click", (e) => {
    const target = e.target.closest("[data-lightbox]")
    if (target) openFrom(target)
  })

  document.addEventListener("keydown", (e) => {
    if ((e.key === "Enter" || e.key === " ") && e.target.matches?.("[data-lightbox]")) {
      e.preventDefault()
      openFrom(e.target)
    }
  })
})()
